export enum UserProfileEvent {
  CREATED = 'TL_USER_PROFILE_CREATED',
  UPDATED = 'TL_USER_PROFILE_UPDATED',
  DELETED = 'TL_USER_PROFILE_DELETED',
}
